/* main_sns.js - v13 (Lazy Load Optimized)
   - 클론 시 video src 제거 → data-src 저장
   - 활성 슬라이드 ±2 범위만 lazy load
   - 나머지 로직 동일
*/
(function () {
  'use strict';

  // ── Lazy Load Helper ──────────────────────────────────
  function loadVideo(video) {
    if (!video || video.dataset.loaded) return;
    const sources = video.querySelectorAll('source[data-src]');
    sources.forEach(source => {
      source.src = source.dataset.src;
      delete source.dataset.src;
    });
    if (!video.src && video.dataset.src) {
      video.src = video.dataset.src;
      delete video.dataset.src;
    }
    video.load();
    video.dataset.loaded = 'true';
  }

  function unloadVideo(video) {
    if (!video || !video.dataset.loaded) return;
    video.pause();
    video.currentTime = 0;
  }

  // ── Strip video src from clones ───────────────────────
  function stripVideoSrc(clone) {
    const video = clone.querySelector('video');
    if (!video) return;
    const sources = video.querySelectorAll('source');
    sources.forEach(source => {
      if (source.src) {
        source.dataset.src = source.src;
        source.removeAttribute('src');
      }
    });
    if (video.src) {
      video.dataset.src = video.src;
      video.removeAttribute('src');
    }
    delete video.dataset.loaded;
  }

  function initSNSCarousel(section) {
    const wrapper = section.querySelector('.main-sns__slider-wrapper');
    const slider  = section.querySelector('.main-sns__slider');

    const realSlides   = Array.from(slider.querySelectorAll('.main-sns__card'));
    const slideCount   = realSlides.length;
    const autoInterval = (parseInt(section.dataset.autoSlide, 10) || 20) * 1000;

    if (slideCount === 0) return;

    // ── Seamless Loop: Clone with src stripped ────────────
    if (slideCount > 0) {
      const beforeClones = realSlides.map(s => {
        const c = s.cloneNode(true);
        stripVideoSrc(c);
        c.setAttribute('aria-hidden', 'true');
        return c;
      });
      const afterClones = realSlides.map(s => {
        const c = s.cloneNode(true);
        stripVideoSrc(c);
        c.setAttribute('aria-hidden', 'true');
        return c;
      });

      beforeClones.forEach(c => slider.insertBefore(c, realSlides[0]));
      afterClones.forEach(c => slider.appendChild(c));
    }

    const allSlides = Array.from(slider.querySelectorAll('.main-sns__card'));
    let timer   = null;
    let busy    = false;

    const startOffset = Math.min(3, slideCount - 1);
    let current = slideCount + startOffset;

    // ── Lazy load ±2 slides around current ───────────────
    function lazyLoadNearby(idx) {
      allSlides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (Math.abs(i - idx) <= 2) {
          loadVideo(video);
        }
      });
    }

    // ── Position Calculation ──────────────────────────────
    function calcOffset(idx) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const slideRect   = allSlides[idx].getBoundingClientRect();
      const wrapperCenter = wrapperRect.left + wrapperRect.width / 2;
      const slideCenter   = slideRect.left   + slideRect.width  / 2;
      const currentTranslate = getCurrentTranslate();
      return currentTranslate + (wrapperCenter - slideCenter);
    }

    function getCurrentTranslate() {
      const style = window.getComputedStyle(slider);
      const matrix = style.transform;
      if (!matrix || matrix === 'none') return 0;
      const values = matrix.match(/matrix.*\((.+)\)/);
      if (!values) return 0;
      const parts = values[1].split(', ');
      return parseFloat(parts[4]) || 0;
    }

    // ── Render Frame ──────────────────────────────────────
    function render(animate) {
      if (animate) {
        slider.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
      } else {
        slider.style.transition = 'none';
        void slider.offsetHeight;
      }

      slider.style.transform = `translateX(${calcOffset(current)}px)`;

      // Lazy load nearby slides
      lazyLoadNearby(current);

      allSlides.forEach((slide, i) => {
        const active = (i === current);
        slide.classList.toggle('is-active', active);

        const video = slide.querySelector('video');
        if (!video) return;
        if (active) {
          loadVideo(video);
          video.currentTime = 0;
          video.play().catch(() => {});
        } else {
          unloadVideo(video);
        }
      });
    }

    // ── Slide Navigation ──────────────────────────────────
    function go(idx, animate = true) {
      if (busy) return;
      busy = true;
      current = idx;
      render(animate);

      if (animate) {
        setTimeout(() => {
          busy = false;
          if (current < slideCount) {
            current += slideCount;
            render(false);
          } else if (current >= slideCount * 2) {
            current -= slideCount;
            render(false);
          }
        }, 520);
      } else {
        busy = false;
      }

      resetTimer();
    }

    const goNext = () => go(current + 1);
    const goPrev = () => go(current - 1);

    // ── Auto-Slide ────────────────────────────────────────
    function isActiveVideoPlaying() {
      const v = allSlides[current] && allSlides[current].querySelector('video');
      return v && !v.paused && !v.ended && v.readyState > 2;
    }

    function autoTick() {
      if (isActiveVideoPlaying()) return;
      goNext();
    }

    function startTimer() {
      if (autoInterval > 0) timer = setInterval(autoTick, autoInterval);
    }
    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    // ── Event Bindings ────────────────────────────────────
    allSlides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) {
        video.addEventListener('ended', () => goNext());
      }
    });

    allSlides.forEach((slide, idx) => {
      slide.addEventListener('click', (e) => {
        if (e.target.closest('.main-sns__add-btn') ||
            e.target.closest('.main-sns__control-btn')) return;
        if (current === idx) return;
        go(idx);
      });

      const video    = slide.querySelector('video');
      const playBtn  = slide.querySelector('.main-sns__control-btn--play');
      const soundBtn = slide.querySelector('.main-sns__control-btn--sound');

      if (video && playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (video.paused) {
            video.play();
            playBtn.querySelector('.icon-pause').style.display = '';
            playBtn.querySelector('.icon-play').style.display  = 'none';
          } else {
            video.pause();
            playBtn.querySelector('.icon-pause').style.display = 'none';
            playBtn.querySelector('.icon-play').style.display  = '';
          }
        });
      }

      if (video && soundBtn) {
        soundBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          video.muted = !video.muted;
          soundBtn.querySelector('.icon-mute').style.display   = video.muted ? '' : 'none';
          soundBtn.querySelector('.icon-unmute').style.display = video.muted ? 'none' : '';
        });
      }
    });

    let touchX = 0;
    wrapper.addEventListener('touchstart', (e) => {
      touchX = e.touches[0].clientX;
    }, { passive: true });
    wrapper.addEventListener('touchend', (e) => {
      const dx = touchX - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) dx > 0 ? goNext() : goPrev();
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearInterval(timer);
      else resetTimer();
    });

    // ── Initialization Observer ───────────────────────────
    let ready = false;
    const ro = new ResizeObserver(() => {
      if (wrapper.offsetWidth === 0) return;
      render(false);
      if (!ready) {
        ready = true;
        startTimer();
      }
    });
    ro.observe(wrapper);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.main-sns').forEach(initSNSCarousel);
  });
})();
